module.exports = __webpack_public_path__ + "files/SPIADI2023 - SFAV.062f50e7eafbd5437aa6d384b6c5e68e.pdf";